import { useMemo } from "react";
import { useSelector } from "react-redux";
import { useFirestoreConnect } from "react-redux-firebase";

import { AppState } from "../reducers";
import { EVENTS_COLLECTION, getSemesterDateRange } from "./shared";

const useSemesterEvents = (semester: string): InfoEvent[] => {
  const dateRange = useMemo(() => getSemesterDateRange(semester), [semester]);

  useFirestoreConnect([
    {
      collection: EVENTS_COLLECTION,
      orderBy: ["date", "asc"],
      ...dateRange,
    },
  ]);

  return useSelector(
    ({ firestore: { ordered } }: AppState) => ordered[EVENTS_COLLECTION] || []
  );
};

export default useSemesterEvents;
